import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFadeOut12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconFadeOut12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#FadeOut12)">
                    <path
                        fill="currentColor"
                        d="M5.49 11.33a.5.5 0 0 1-.106-.013A5.35 5.35 0 0 1 .627 6.002l.008-.275A5.35 5.35 0 0 1 5.37.69a.5.5 0 0 1 .12-.02.45.45 0 0 1 .45.45v9.758a.45.45 0 0 1-.45.45m1.813-.263a.45.45 0 0 1-.45-.45V1.384a.45.45 0 0 1 .9 0v9.233a.45.45 0 0 1-.45.45M5.039 1.656a4.447 4.447 0 0 0 0 8.693zm4.073 8.449a.45.45 0 0 1-.45-.45V2.343a.451.451 0 0 1 .9 0v7.312a.45.45 0 0 1-.45.45m1.812-1.632a.45.45 0 0 1-.45-.45V3.978a.451.451 0 0 1 .9 0v4.045a.45.45 0 0 1-.45.45"
                    />
                </g>
                <defs>
                    <clipPath id="FadeOut12">
                        <path fill="#fff" d="M0 12h12V0H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconFadeOut12);
